import { useEffect, useRef ,useState } from "react";
// import * as Tetavi from '../TetaviBundle.js'
import ControlBar from "./ControlBar"
import PortraitControlBar from "./PortraitControlBar";
import {OrbitControls}  from 'three/examples/jsm/controls/OrbitControls'
import json from "../my-particle-system.json";
import { useParams,useLocation } from 'react-router-dom'
import HoveredAnimationTutorial from './HoveredAnimationTutorial'
import TetaviObj from "./TetaviObj";
import GlbObj from "./GlbObj"
import Light from "./Light"
import { Clock } from 'three';
import {RGBELoader} from "three/examples/jsm/loaders/RGBELoader";
import  Particle  from "./Particle";
import LoadingPage from './LoadingPage.js'
// import RestartPage from './RestartPage.js'
// import Menu from "./Menu";
// import InfoItems from "components/InfoItems"
import Util from "components/utils"
import ReactGA from 'react-ga';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'; 

// import * as THREE from "three";

// import io from "socket.io-client";
let debug = false;


const Animate = (props) => {

  const mountRef = useRef(null);
  const THREE = window.Tetavi.THREE;
  
  const [tetavi, setTetavi] = useState({});
  const [firstPlay, setFirstPlay] = useState(true);
  const [tick, setTick] = useState(0);
  const [time, setTime] = useState(Date.now());
  const [updateables, setUpdateables] = useState([]);
  const [playState, setPlayState] = useState("init"); 
  const [tetaviPlayer, setTetaviPlayer] = useState([]); 
  const [particles, setParticles] = useState([]);
  const [likes, setLikes] = useState([]); 
  const [fades, setFades] = useState(null);
  const [glbs, setGlbs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingGlbs, setLoadingGlbs] = useState(true);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [lights, setLights] = useState([]);
  // const [viewNumber, setViewNumber] = useState(0);
  // const [likesSpan, setLikeSpan] = useState(0);
  // const [likeTotalView, setLikeTotalView] = useState(0);
  const [analyser, setAnalyser] = useState(null);
  const [audioArray, setAudioArray] = useState([]);
  const [tetPivot, setTetPivot] = useState(new THREE.Object3D());
  const [videos, setVideos] = useState([]);
  const [progress, setProgress] = useState(0);
  const [iOSDevice, setIOSDevice] = useState(false);
  const [totalToLoad, setTotalToLoad] = useState(0);
  const [loaded, setLoaded] = useState(0);
  const [endingPage, setEndingPage] = useState(false);
  const [lightUpdateables, setLightUpdateables] = useState([]);
  const [cameraMoved, setCameraMoved] = useState(false);

  const [textMesh, setTextMesh] = useState(0);

  const [controls, setControls] = useState(null);

  const [camera, setCamera] = useState(new THREE.PerspectiveCamera( 60, window.innerWidth/window.innerHeight, 0.01, 1000 ));
  
  const clock = new Clock();
  let Tetavi = window.Tetavi;
  
  let saved_frame = -1
  let globalFrame = 0;
  const {search} = useLocation();

  const query = new URLSearchParams(search);
  const concert = query.get('concert');
  // const socketHost = window.config.urls.webSocket;
  // const socketHost = 'api.prod.immersivefs.com';

  const socketPort =  443;

  const concertName = concert;
  // const viewsChannel = concertName+"_views_channel"
  // const viewMessage = concertName+"_view"
  const loaderText = new FontLoader();

  // const statsChannel = "statistics_"+concertName

  
  
  
    // this adds the preset to tsParticles, you can safely use the
    
    const manager = new THREE.LoadingManager();
    
    

    function initRender(){
      const clock = new THREE.Clock();
      changeBackGroundClicked(0)
      audioChanged(0)
      let delta = 0;
      // 30 fps
      let interval = 1 / 30;
      props.renderer.toneMapping  = THREE.ReinhardToneMapping
      props.renderer.setAnimationLoop( async function () {
        controls.update();
        delta += clock.getDelta();
        if (delta  > interval) {
          await Tick(delta);
          props.renderer.render( props.scene, camera );
        }
        
        delta = delta % interval;
      } );
    }

    function checkLoading(){
      (loading) ? setLoaded(updateables.length + 1) : setLoaded(updateables.length)
      if(tetaviPlayer.length > 0 && !tetaviPlayer[0].isReady()){
        
        tetaviPlayer[0].tick(0);
      }
      if(loading && !loadingGlbs && tetaviPlayer.length > 0 && tetaviPlayer[0].isReady()){
        setLoading(false)
        
        
      }
    }

    function setTetFolowBone(){
      for (const object of updateables) {
        const animation = object.getBoneAnimation()
        
        if(animation.length > 0 ){
          if(animation[0].tracks.length > 0){
            
            for( const track of animation[0].tracks){
              // bone animation is split into 3 animation tracks ending in .position .scale .quaternion
              if(tetPivot.boneToFollow == track.name.split(".")[0]){
                Util.setFolowAnimationFromBone(tetPivot,track.values,track.name.split(".")[1])
              }
            }
          }

        }
      
      }
    }

    useEffect(() => {
      checkLoading()
      if(loadingGlbs == false&&loading==false && controls){
        initRender()
        setTetFolowBone()
      }
    }, [loadingGlbs,loading,controls]);
    
    const cameraFront = new Tetavi.THREE.Vector3() ;
			var geometry;
      // const sprite = new Tetavi.THREE.TextureLoader().load( './like.png' );
      //const sprite = props.likeSprite;

      async function fetchAddLike(){
        
        let frame
        if(tetaviPlayer && tetaviPlayer.length>0 && (playState =="first_play" || playState == "pause" ||"first_play"|| playState =="play") ){
          frame= Math.round(tetaviPlayer[0].getFrame()/30)
        }else{
          return
        }
          
        
        fetch(window.config.urls.concertBackend +'api/v1/add_like?name='+ props.concert
         + '&index='+frame ).then(result => console.log(result))
      }

			// async function likeClick(number,is_user) 
			// { 
        
      //   const sprite = (is_user) ? props.likeSprite.my : props.likeSprite.other;
			// 	props.scene.remove( likes );
			// 	geometry = new Tetavi.THREE.BufferGeometry();
			// 	const vertices = [];
			// 	const colors = [];
			// 	const color = new Tetavi.THREE.Color();
				
			// 	const n = number;
			// 	for ( let i = 0; i < n; i ++ ) {

					
			// 		/*var pos = Tetavi.THREE.Vector3( (Math.random()*2-1)*10,(Math.random()*2-1)*3, 0  )
			// 		pos.normalize();*/
			// 		camera.getWorldDirection(cameraFront ) ;
			// 		cameraFront.y  = 0;
			// 		// cameraFront*=10;
      //     if(is_user){
      //       // setLikeTotalView(likeTotalView => likeTotalView+number)
      //       fetchAddLike();
      //       vertices.push( (Math.random()-0.5)*10,0, 5 + Math.random()*5);
      //     }else{
      //       vertices.push( (Math.random()-0.5)*10,0, 5 + Math.random()*5);
      //       color.setRGB( 0.5+Math.random()*0.5, Math.random()*0.3, Math.random()*0.3 );
      //     }
					

			// 		colors.push( color.r, color.g, color.b );

			// 	}

			// 	geometry.setAttribute( 'position', new Tetavi.THREE.Float32BufferAttribute( vertices, 3 ) );
			// 	geometry.setAttribute( 'color', new Tetavi.THREE.Float32BufferAttribute( colors, 3 ) );

			// 	var material = new Tetavi.THREE.PointsMaterial( { size: 2 + Math.random()*2, sizeAttenuation: true, map: sprite, alphaTest: 0.5, transparent: false ,vertexColors: true} );
      //   material.toneMapped = false
			// 	//material.color = new Tetavi.THREE.Color("rgb(255, 0, 0)");
      //   const l = new Tetavi.THREE.Points( geometry, material )
      //   l.lookAt(cameraFront)
      //   l.position.set(cameraFront.x,cameraFront.y,cameraFront.z)
			// 	likes.push(l);
        
			// 	moveParticles(likes[likes.length -1]);
			// 	props.scene.add( likes[likes.length -1]);
      //   setLikes(likes)
			// }

  useEffect(() => {
    
    if(!mountRef.current) return
    props.renderer.setSize( window.innerWidth, window.innerHeight );
    mountRef.current.appendChild( props.renderer.domElement );
    
    camera.position.z = -5; 
    

    let onWindowResize = function () {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      props.renderer.setSize( window.innerWidth, window.innerHeight );
    }

    window.addEventListener("resize", onWindowResize, false);
    props.renderer.domElement.addEventListener('click', onClick, false);
    props.renderer.domElement.addEventListener('touchstart', onTouch);
    
    camera.position.z = 14;
    camera.position.y = 1.5;
    /*const ambient= new Tetavi.THREE.AmbientLight( 0x999999 )
    ambient.intensity = 1;
    props.scene.add( ambient );*/
    const pmremGenerator = new Tetavi.THREE.PMREMGenerator(props.renderer);
    const rgbeLoader = new RGBELoader(manager);
    rgbeLoader.load('https://threejs.org/examples/textures/equirectangular/venice_sunset_1k.hdr', function(texture,textureData )
    {
      const envMap = pmremGenerator.fromEquirectangular(texture).texture;
      props.scene.background = (0,0,0);
      props.scene.environment = envMap;
      texture.dispose();
    });
    setVideos(props.config.videos)
  
    let isios = !!navigator.platform.match(/iPhone|iPod|iPad/)
    setIOSDevice(isios)
    if(isios){
      window.createImageBitmap = undefined
    }
    
    return () => mountRef.current.removeChild( props.renderer.domElement);
  }, []);

  function onTouch(event) {
    event.preventDefault();
    detectCollision((event.touches[0].clientX / window.innerWidth) * 2 - 1,-(event.touches[0].clientY / window.innerHeight) * 2 + 1)
  }

  function onClick(event) {
    event.preventDefault();
    detectCollision((event.clientX / window.innerWidth) * 2 - 1,-(event.clientY / window.innerHeight) * 2 + 1)
  }

  function detectCollision(clientX,clientY) {
    let candidates = [...updateables]
    for(const glb of updateables){
      const bounding_box = glb.creatBoundingBox()
      if(bounding_box){
        candidates.push(bounding_box)
      }
    }

    let mouse = new THREE.Vector2()
    let raycaster = new THREE.Raycaster();
    mouse.x = clientX;
    mouse.y = clientY;
    raycaster.setFromCamera(mouse, camera);
  
    var intersects = raycaster.intersectObjects(candidates, true);
  
    if (intersects.length > 0) {
      if(intersects[0].object.name === "clickable"){
        const obj = intersects[0].object
        obj.onClick({camera,controls,tetPivot,ReactGA,THREE,frame:getFrame(),"numClicks":obj.numClicks,"setNumClicks":obj.setNumClicks})
      }
    }
  
  }

  function createText(text){
    return
    loaderText.load("./text/Uni Sans Thin CAPS_Regular.json",(font) => {
      const textGeometry = new TextGeometry(text,{
        font:font,
        size:3,
        height:2
      })
      const tmpTextMesh = new THREE.Mesh(textGeometry,[
        new THREE.MeshPhongMaterial({color: 0xad4000})
      ])
      tmpTextMesh.position.y = 3
      tmpTextMesh.position.x = -8
      tmpTextMesh.position.z = -8
      props.scene.remove(textMesh)
      setTextMesh(tmpTextMesh)
      props.scene.add(tmpTextMesh)
    })
  }
  
  
  useEffect(() => {
    if(loading){
      const interval = setInterval(() => {setTime(Date.now());
          
          if(loading){
            setTick(tick => tick+1);
            Tick(0);
          }          
      }, 300);
      
      return () => {
        clearInterval(interval);
      };
    }
  }, [tick]);

  useEffect(() => {
    if(!props.config) return
    if(props.config.fades)
      setFades(props.config.fades)
    if(props.config.tetavi_player)
      setTetavi(props.config.tetavi_player)
    if(props.config.glbs){
      setTotalToLoad(props.config.glbs.length + 1)
      setGlbs(props.config.glbs)
    }
      
    if(props.config.camera_control){
      var _controls = new OrbitControls( camera, props.renderer.domElement );
       
      _controls = Util.setFromConfig(_controls,props.config.camera_control)
      
      _controls.update();
      // analitics of camera moved
      _controls.addEventListener( 'change', changeDetect);
      setControls(_controls)
    
    }
    if(props.config.debug){
      debug = props.config.debug
    }
    if(props.config.lights){
      setLights(props.config.lights)
    }
    if(props.config.tetavi_player){
      // create player animation and assigen PerFrameFunctions to it
      setTetPivot(Util.setFromConfig(tetPivot,props.config.tetavi_player))

    }
    if(props.config.loading_info){
      setLoadingText(props.config.loading_info)
    }
    
    
  }, [props.config]);


  function changeDetect(){
    if(controls)
    controls.removeEventListener( 'change',changeDetect);
  }


  
  function Tick(delta) {
    // 
    let frame = getFrame()
    if(frame < 0) return
    //syncVideos()
    /*if(likesSpan.length > 0 && frame%30 == 0 && frame != 0 ){
      const numlikes = likesSpan[frame/30].n
      likeClick(numlikes,false)
    }*/
    
    for( const light of lightUpdateables){
      
      if(light.PerFrameFunctions){
        for(const lightFunc of light.PerFrameFunctions){
          
          lightFunc(light,frame)
        }
      }
      
    }
    


    if(loading){
      checkLoading()
    }
    for (const tetPlayer of tetaviPlayer) {

      tetPlayer.tick(delta);
    }

    if(tetPivot.PerFrameFunctions){
      for(const tetPivotFunc of tetPivot.PerFrameFunctions){
        tetPivotFunc(tetPivot,frame)
      }
    }
    
      
    for (const object of updateables) {
      
      object.tick(delta,frame);
      
      
    }

    for(var i = 0; i < likes.length;i++){
      moveParticles(likes[i]);
    }
    for (const prtcl of particles) {
      
      if(prtcl)
        prtcl.tick(delta,frame);
    }
    /*if(analyser && audioArray.length > 0){
      
      analyser.getByteFrequencyData(audioArray);
      props.scene.traverse( function( object ) {
  
        if ( object.isMesh ){
          // object.material.displacementScale = 5
          // object.material.freq = audioArray[ 100 ] / 2000
          const shader = object.material.userData.shader;

						if ( shader ) {

							shader.uniforms.freq.value = audioArray[ 100 ] / 1000;
              shader.uniforms.time.value = frame/30;
						}
        } 
    
      } );
    }*/
  }

  const setupAudioContext = (videoId) => {
    var audioContext = new window.AudioContext();
    
    let audioArray = []
    var audioElement = document.getElementById(videoId);
    var source = audioContext.createMediaElementSource(audioElement);
    let analysert = audioContext.createAnalyser();
    source.connect(analysert);
    analysert.connect(audioContext.destination);
    analysert.fftSize = 1024;
    audioArray = new Uint8Array(analysert.frequencyBinCount);
    setAnalyser(analysert)
    setAudioArray(audioArray)

  };

  function changeBackGroundClicked(backNum)  {
    const fix = (backNum) %3;
    
    for (let i = 0 ; i < updateables.length ; i++) {
      
      updateables[i].hide(updateables[i].glbIndex != fix)
      
      
    }
  }

  function showEndingPage()  {
    
    setEndingPage(true)
  }
  // audio comes from tet or outside video
  function handleAudioSrc(audio_src){
    if(audio_src){
      tetaviPlayer[0].getSrcVideo().muted = false;
      for(const vid of videos){
        document.getElementById(vid.videoId).muted =true;
      }
    }else{
      tetaviPlayer[0].getSrcVideo().muted = true;
      for(const vid of videos){
        document.getElementById(vid.videoId).muted =false;
      }
    }
  }

    
  function playClick ()
  {    
    let concertLabel =  JSON.stringify(concert)
      if (playState == "init")
      {
          /*if (tetaviPlayer.length > 0){
            tetaviPlayer[0].getSrcVideo().onended = showEndingPage;
          }*/
          //handleAudioSrc(props.config.tetavi_player.audio)
          setPlayState("first_play");
      }
      if (playState == "first_play")
      {
          setPlayState("pause");
      }
      if (playState == "pause")
      {
          setPlayState("play");
      }
      if (playState == "play")
      {
          setPlayState("pause");
      }
      if (playState == "buffering")
      {
          setPlayState("pause");

      }
  }

  async function moveParticles(particle){
    const time = 0.05;
    // console.log(particle.position.y)
    if(particle){
      
      particle.position.y += time;
      particle.position.x += Math.sin(particle.position.y)*Math.random()*time
      if(particle.position.y >= 25){
        props.scene.remove( particle );
        likes.shift();
      }
    }
  }

  async function audioChanged(val){
    if (tetaviPlayer.length > 0){
      tetaviPlayer[0].getSrcVideo().volume =val 
      for(const vid of videos){
        document.getElementById(vid.videoId).volume =val ;
      }
    }
  }

  function getFrame(){
    let frame= -1
    
    if(tetaviPlayer.length > 0) {
      frame= Math.round(tetaviPlayer[0].getFrame())
      if(frame != saved_frame){
        saved_frame = frame
        const p = frame*100 / tetaviPlayer[0].getTotalFrames();
        if(p% 1 < 0.1){
          setProgress(p)
        }
      }        
    } 
    return frame;

  }

  function seekToFrame(percent){
    return;
    // if(iOSDevice) return;
    if (tetaviPlayer.length > 0){
      tetaviPlayer[0].getSrcVideo().currentTime =percent* tetaviPlayer[0].getSrcVideo().duration
      for(const vid of videos){
        document.getElementById(vid.videoId).currentTime =percent* document.getElementById(vid.videoId).duration
      }
    }

  }

  function syncVideos(){
    // if(iOSDevice) return;
    if (tetaviPlayer.length > 0){
      for(const vid of videos){
        if(tetaviPlayer[0].getSrcVideo().currentTime +1 >= document.getElementById(vid.videoId).duration) continue;
        if( document.getElementById(vid.videoId).currentTime + 1 < tetaviPlayer[0].getSrcVideo().currentTime || document.getElementById(vid.videoId).currentTime >  tetaviPlayer[0].getSrcVideo().currentTime + 1){
          document.getElementById(vid.videoId).currentTime  =tetaviPlayer[0].getSrcVideo().currentTime;
          setPlayState("buffering");
          setTimeout(function () {
            setPlayState("play");
          }, 5000);
        }  
      }
    }

  }


  function onAutoRotateClicked(bool){
    controls.autoRotate = bool;
    
  }

  function onChangeShader(shaderNumber){
    for (const tetPlayer of tetaviPlayer) {
      tetPlayer.ChangeShader(0)
      if(shaderNumber == 2){
        const FragWithNormals = `\
    varying vec2 vUv;
    varying vec3 tNormal;
    varying vec3 objectPos;
    uniform sampler2D tDiffuse;
    uniform float tAlpha;
    uniform sampler2D normalsRenderTarget;
    uniform float customParam;



    vec3 CalcPointLight(vec3 normal, vec3 fragPos,vec3 lightPos,vec3 lightColor)
    {
        vec3 lightDir = normalize(lightPos - fragPos);
        // diffuse shading
        float diff = max(dot(normal, lightDir), 0.0);
        // specular shading
        vec3 reflectDir = reflect(-lightDir, normal);
        // attenuation
        float distance    = length(lightPos - fragPos);
        float attenuation = 1.0 / (0.5 +  (distance) +   (0.2* distance * distance));    
        // combine results
        vec3 ambient  = vec3(0.8,0.8,0.8);
        vec3 diffuse  = lightColor  * diff;
        return (ambient + diffuse ) * vec3(texture2D(tDiffuse, vUv));
    } 

    void main() {
      vec3 normal = normalize(tNormal);
      vec3 color = CalcPointLight(normal,objectPos,vec3(2.,2.,1.),vec3(1.0,0.0,0.0));
      gl_FragColor = vec4(color.xyz,1.);
    }
`;
        tetPlayer.setNormalsShader(FragWithNormals); // use "" for default light-normal shader or 'null' for no normals calculation
        //tetPlayer.setNormalsUniforms({"customParam": { "value": 0.5}});
      }else
        tetPlayer.ChangeShader(shaderNumber)
    }
    
    
    
  }

  return (
    (props.config) ? (
    <div ref={mountRef} >

      {/* {(endingPage) ? <RestartPage endingPage={endingPage} text={loadingText} restart={restart} /> : null} */}
      {(loading||loadingGlbs) ? 
      (
        <LoadingPage onPlayClick={playClick}  setLoadingGlbs={setLoadingGlbs} loading={loading} loaded={loaded} totalToLoad={totalToLoad} manager={manager} text={loadingText} img={'./images/track.png'}/>)
         : 
        <div className="app-animate-div">
            <ControlBar playState={playState} seekToFrame={seekToFrame} progress={progress} audioChanged={audioChanged} onPlayClick={playClick} />
            <PortraitControlBar changeBackGroundClicked={changeBackGroundClicked} onAutoRotateClicked={onAutoRotateClicked} onChangeShader={onChangeShader}/>
             {(((props.clickTouch) || (cameraMoved)) ? null:<HoveredAnimationTutorial/>)}
          </div>}        
        <TetaviObj  fades={fades} tetaviPlayer={tetaviPlayer} setTetaviPlayer={ setTetaviPlayer} scene={props.scene} camera={camera} renderer={props.renderer} tick={tick} playState={playState} Tetavi ={Tetavi}  pivot={tetPivot} tetavi_player={tetavi} />               
        {glbs.map((glb,key) => {
          return (
          <div key={key}>
            <GlbObj index={key} debug={debug} config={props.config} loadingManager={manager} updateables={updateables} setUpdateables={ setUpdateables} scene={props.scene} camera={camera} renderer={props.renderer} playState={playState}  pivot={new THREE.Object3D()} glb={glb}/>
          </div>)
        })}
        {lights.map((_light,key) => {
                return (
                <div key={key}>
                    <Light debug={props.config.debug} lightUpdateables={lightUpdateables} setLightUpdateables={setLightUpdateables} scene={props.scene} light={_light}/>
                </div>)
                })}
        {/* <Particle particles = {particles} setParticles={setParticles} props.scene={props.scene}  props.renderer={props.renderer} frameIn={100} frameOut={300} /> */}
    </div>   
  ):null)
}

export default Animate;